import * as tslib_1 from "tslib";
import axios from 'axios';
import { BadRequest, InternalServerError, NotFound } from 'ts-httpexceptions';
import { UtilsService } from "../common/utils.service";
import * as i0 from "@angular/core";
import * as i1 from "../common/utils.service";
export class RepositoryService {
    constructor(utilsService) {
        this.utilsService = utilsService;
        this.saveSurvey = (data) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            let res = null;
            let endpoint = this.utilsService.getEndpoint() + '/survey/structure/save';
            try {
                res = yield axios.post(endpoint, data);
            }
            catch (err) {
                switch (err.response.status) {
                    case 400:
                        throw new BadRequest(err);
                    case 404:
                        throw new NotFound(err);
                    default:
                        throw new InternalServerError(err);
                }
            }
            if (!!res && res.status === 201) {
                return res.data.data;
            }
            throw new Error('Unexplainable error');
        });
        this.editSurvey = (data) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            let res = null;
            let endpoint = this.utilsService.getEndpoint() + '/survey/structure/edit/' + data['id'];
            try {
                res = yield axios.post(endpoint, data);
            }
            catch (err) {
                switch (err.response.status) {
                    case 400:
                        throw new BadRequest(err);
                    case 404:
                        throw new NotFound(err);
                    default:
                        throw new InternalServerError(err);
                }
            }
            if (!!res && res.status === 201) {
                return res.data.data.surveyStructure;
            }
            throw new Error('Unexplainable error');
        });
        this.deleteSurvey = (surveyId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            let res = null;
            let endpoint = this.utilsService.getEndpoint() + '/survey/structure/delete/' + surveyId;
            try {
                res = yield axios.delete(endpoint);
            }
            catch (err) {
                switch (err.response.status) {
                    case 400:
                        throw new BadRequest(err);
                    case 404:
                        throw new NotFound(err);
                    default:
                        throw new InternalServerError(err);
                }
            }
            if (!!res && res.status === 204) {
                return res.data.data;
            }
            throw new Error('Unexplainable error');
        });
        this.copySurvey = (surveyId, name) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            let res = null;
            let endpoint = this.utilsService.getEndpoint() + '/survey/structure/copy';
            try {
                res = yield axios.post(endpoint, { id: surveyId, name: name });
            }
            catch (err) {
                switch (err.response.status) {
                    case 400:
                        throw new BadRequest(err);
                    case 404:
                        throw new NotFound(err);
                    default:
                        throw new InternalServerError(err);
                }
            }
            if (!!res && res.status === 200) {
                return res.data.data;
            }
            throw new Error('Unexplainable error');
        });
        this.getSurvey = (surveyId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            //return new Promise((resolve) => resolve({"name":"dgv","type":"checkout","from":"2020-08-11","to":"2020-08-11","projects":[{"id":"37bd1bda-d7de-11ea-8917-0242ac1f0002","name":"GLO 121 - BRITISH AMERICAN TOBACCO"},{"id":"37bf507c-d7de-11ea-8917-0242ac1f0002","name":"GLO TEST - BRITISH AMERICAN TOBACCO"},{"id":"37c1fb5d-d7de-11ea-8917-0242ac1f0002","name":"GLO 121 - UNIEURO - BRITISH AMERICAN TOBACCO"},{"id":"37c4c2c9-d7de-11ea-8917-0242ac1f0002","name":"GLO 121 - BRITISH AMERICAN TOBACCO (PRICE INCREASE)"},{"id":"37c74a4f-d7de-11ea-8917-0242ac1f0002","name":"GLO 121 - AIRPORT - BRITISH AMERICAN TOBACCO (PRICE INCREASE)"},{"id":"37c9fd43-d7de-11ea-8917-0242ac1f0002","name":"GLO 121 - WINTER -  BRITISH AMERICAN TOBACCO (PRICE INCREASE)"},{"id":"37cc9600-d7de-11ea-8917-0242ac1f0002","name":"FMC TEST - BRITISH AMERICAN TOBACCO"},{"id":"37cf5082-d7de-11ea-8917-0242ac1f0002","name":"GLO 121 - BRITISH AMERICAN TOBACCO Q2"},{"id":"37d1d73f-d7de-11ea-8917-0242ac1f0002","name":"GLO 121 - CENTRI COMMERCIALI - BRITISH AMERICAN TOBACCO"},{"id":"37d49791-d7de-11ea-8917-0242ac1f0002","name":"GLO 121 - SUMMER 2020 - BRITISH AMERICAN TOBACCO"}],"positions":[{"regions":[],"provinces":[],"cities":[],"isNational":true}],"questions":[{"id":"1597151179652","type":"text","required":true,"question":"xv","answers":[]},{"id":"1597151184347","type":"select","required":false,"question":"dfcb","answers":[{"id":"1597151188153","value":"sdgv"},{"id":"1597151189330","value":"sgv"}]},{"id":"1597151190849","type":"multiselect","required":true,"question":"dgvx","answers":[{"id":"1597151196152","value":"sdgv"},{"id":"1597151197518","value":"sd"},{"id":"1597151211388","value":"zsdfgxv"}]}]}));
            //return new Promise((resolve) => resolve({"name":"dgv","type":"checkout","from":"2020-08-11","to":"2020-08-11","projects":[{"id":"37bd1bda-d7de-11ea-8917-0242ac1f0002","name":"GLO 121 - BRITISH AMERICAN TOBACCO"},{"id":"37bf507c-d7de-11ea-8917-0242ac1f0002","name":"GLO TEST - BRITISH AMERICAN TOBACCO"},{"id":"37c1fb5d-d7de-11ea-8917-0242ac1f0002","name":"GLO 121 - UNIEURO - BRITISH AMERICAN TOBACCO"},{"id":"37c4c2c9-d7de-11ea-8917-0242ac1f0002","name":"GLO 121 - BRITISH AMERICAN TOBACCO (PRICE INCREASE)"},{"id":"37c74a4f-d7de-11ea-8917-0242ac1f0002","name":"GLO 121 - AIRPORT - BRITISH AMERICAN TOBACCO (PRICE INCREASE)"},{"id":"37c9fd43-d7de-11ea-8917-0242ac1f0002","name":"GLO 121 - WINTER -  BRITISH AMERICAN TOBACCO (PRICE INCREASE)"},{"id":"37cc9600-d7de-11ea-8917-0242ac1f0002","name":"FMC TEST - BRITISH AMERICAN TOBACCO"},{"id":"37cf5082-d7de-11ea-8917-0242ac1f0002","name":"GLO 121 - BRITISH AMERICAN TOBACCO Q2"},{"id":"37d1d73f-d7de-11ea-8917-0242ac1f0002","name":"GLO 121 - CENTRI COMMERCIALI - BRITISH AMERICAN TOBACCO"},{"id":"37d49791-d7de-11ea-8917-0242ac1f0002","name":"GLO 121 - SUMMER 2020 - BRITISH AMERICAN TOBACCO"}],"positions":[{"regions":[{id: '16972843-dc97-11ea-904e-0242ac1f0002', name: 'Abruzzo'}],"provinces":[{id: '16db78a6-dc97-11ea-904e-0242ac1f0002', name: 'Napoli'}],"cities":[{id: '1749b46c-dc97-11ea-904e-0242ac1f0002', name: 'Bari'}],"isNational":false}, {"regions": [{id: 'tdfj', name: 'erfj'}], "provinces": [{id: 'dfjn', name: 'dfjn'}], "cities": [{id: 'dfh', name: 'dsfh'}], "isNational": false}, {"regions": [{id: 'rsdhg', name: 'ezrsdhg'}], "provinces": [], cities: [], "isNational": false}],"questions":[{"id":"1597151179652","type":"text","required":true,"question":"xv","answers":[]},{"id":"1597151184347","type":"select","required":false,"question":"dfcb","answers":[{"id":"1597151188153","value":"sdgv"},{"id":"1597151189330","value":"sgv"}]},{"id":"1597151190849","type":"multiselect","required":true,"question":"dgvx","answers":[{"id":"1597151196152","value":"sdgv"},{"id":"1597151197518","value":"sd"},{"id":"1597151211388","value":"zsdfgxv"}]}]}));
            let res = null;
            let endpoint = this.utilsService.getEndpoint() + '/survey/structure/' + surveyId;
            try {
                res = yield axios.post(endpoint, { id: surveyId });
            }
            catch (err) {
                switch (err.response.status) {
                    case 400:
                        throw new BadRequest(err);
                    case 404:
                        throw new NotFound(err);
                    default:
                        throw new InternalServerError(err);
                }
            }
            if (!!res && res.status === 200) {
                return res.data.data.surveyStructure;
            }
            throw new Error('Unexplainable error');
        });
    }
    getProjects() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let res = null;
            let endpoint = this.utilsService.getEndpoint() + '/projects';
            try {
                res = yield axios.post(endpoint);
            }
            catch (err) {
                switch (err.response.status) {
                    case 400:
                        throw new BadRequest(err);
                    case 404:
                        throw new NotFound(err);
                    default:
                        throw new InternalServerError(err);
                }
            }
            if (!!res && res.status === 200) {
                return res.data.data.projects;
            }
            throw new Error('Unexplainable error');
        });
    }
    getRegioni() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //return new Promise((resolve) => resolve([{id: '1', name: 'Reg 1'}, {id: '2', name: "Reg 2"}]));
            let res = null;
            let endpoint = this.utilsService.getEndpoint() + '/location/regions';
            try {
                res = yield axios.post(endpoint);
            }
            catch (err) {
                switch (err.response.status) {
                    case 400:
                        throw new BadRequest(err);
                    case 404:
                        throw new NotFound(err);
                    default:
                        throw new InternalServerError(err);
                }
            }
            if (!!res && res.status === 200) {
                return res.data.data.regions;
            }
            throw new Error('Unexplainable error');
        });
    }
    getProvinceByRegione(regioneId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //return new Promise((resolve) => resolve([{id: '1', name: 'Prov 1' + regioneId}, {id: '2', name: "Prov 2"}]));
            let res = null;
            let endpoint = this.utilsService.getEndpoint() + '/location/provinces';
            try {
                res = yield axios.post(endpoint, { ids: regioneId });
            }
            catch (err) {
                switch (err.response.status) {
                    case 400:
                        throw new BadRequest(err);
                    case 404:
                        throw new NotFound(err);
                    default:
                        throw new InternalServerError(err);
                }
            }
            if (!!res && res.status === 200) {
                return res.data.data.provinces;
            }
            throw new Error('Unexplainable error');
        });
    }
    getComuniByProvincia(provinciaId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //return new Promise((resolve) => resolve([{id: '1', name: 'Com 1' + provinciaId}, {id: '2', name: "Com 2"}]));
            let res = null;
            let endpoint = this.utilsService.getEndpoint() + '/location/cities';
            try {
                res = yield axios.post(endpoint, { ids: provinciaId });
            }
            catch (err) {
                switch (err.response.status) {
                    case 400:
                        throw new BadRequest(err);
                    case 404:
                        throw new NotFound(err);
                    default:
                        throw new InternalServerError(err);
                }
            }
            if (!!res && res.status === 200) {
                return res.data.data.cities;
            }
            throw new Error('Unexplainable error');
        });
    }
    getSurveysList(filters) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let res = null;
            let endpoint = this.utilsService.getEndpoint() + '/survey/structure/list';
            try {
                res = yield axios.post(endpoint, filters);
            }
            catch (err) {
                switch (err.response.status) {
                    case 400:
                        throw new BadRequest(err);
                    case 404:
                        throw new NotFound(err);
                    default:
                        throw new InternalServerError(err);
                }
            }
            if (!!res && res.status === 200) {
                return res.data.data.rows;
            }
            throw new Error('Unexplainable error');
        });
    }
}
RepositoryService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RepositoryService_Factory() { return new RepositoryService(i0.ɵɵinject(i1.UtilsService)); }, token: RepositoryService, providedIn: "root" });
